import React from 'react';

const ALL_ICONS = [
  { id: 'summary', emoji: '⚡', label: 'Smart Summary' },
  { id: 'notif',   emoji: '🔔', label: 'Notifications' },
  { id: 'cal',     emoji: '📅', label: 'Calendar' },
];

const THEMES = [
  { id: 'light',    name: '☀️ Light',    swatch: 'linear-gradient(135deg,#4f82f6,#34d399,#a78bfa)' },
  { id: 'dark',     name: '🌙 Dark',     swatch: 'linear-gradient(135deg,#1a3a8f,#0f6e5a,#4a1d8a)' },
  { id: 'ocean',    name: '🌊 Ocean',    swatch: 'linear-gradient(135deg,#06b6d4,#10b981,#6366f1)' },
  { id: 'warm',     name: '🌅 Warm',     swatch: 'linear-gradient(135deg,#f97316,#eab308,#ec4899)' },
  { id: 'forest',   name: '🌿 Forest',   swatch: 'linear-gradient(135deg,#22c55e,#10b981,#65a30d)' },
  { id: 'lavender', name: '💜 Lavender', swatch: 'linear-gradient(135deg,#8b5cf6,#a78bfa,#ec4899)' },
  { id: 'midnight', name: '🌑 Midnight', swatch: 'linear-gradient(135deg,#4a044e,#7c3aed,#be185d)' },
  { id: 'slate',    name: '🩶 Slate',    swatch: 'linear-gradient(135deg,#1e3a5f,#334155,#0e7490)' },
  { id: 'carbon',   name: '⬛ Carbon',   swatch: 'linear-gradient(135deg,#1f2937,#374151,#4b5563)' },
];

interface Props {
  activeIcons: string[];
  onToggle: (id: any) => void;
  colorTheme: string;
  onThemeChange: (id: string) => void;
}

const ManageTab: React.FC<Props> = ({ activeIcons, onToggle, colorTheme, onThemeChange }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, minHeight: '100%' }}>

      {/* Icons */}
      <div>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--text-color-calendar-week)', marginBottom: 8 }}>
          Panel icons
        </div>
        {ALL_ICONS.map(icon => {
          const active = activeIcons.includes(icon.id);
          return (
            <div
              key={icon.id}
              onClick={() => onToggle(icon.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '9px 11px', borderRadius: 10, cursor: 'pointer', marginBottom: 5,
                background: active ? 'var(--active-nav)' : 'var(--surface2)',
                border: `1px solid ${active ? 'rgba(37,99,235,.18)' : 'var(--border-new)'}`,
                transition: 'all .15s',
              }}
            >
              <span style={{ fontSize: 16 }}>{icon.emoji}</span>
              <span style={{ flex: 1, fontSize: 12, fontWeight: 600, color: 'var(--text-new)' }}>{icon.label}</span>
              <div style={{ width: 36, height: 20, borderRadius: 10, position: 'relative', background: active ? '#2563eb' : 'var(--border-new)', transition: 'background .2s', flexShrink: 0 }}>
                <div style={{ position: 'absolute', width: 14, height: 14, borderRadius: '50%', background: 'white', top: 3, left: active ? 19 : 3, transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }} />
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ flex: 1 }} />

      {/* Theme */}
      <div>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--text-color-calendar-week)', marginBottom: 8 }}>
          Colour theme
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 7 }}>
          {THEMES.map(t => {
            const active = colorTheme === t.id;
            return (
              <div
                key={t.id}
                onClick={() => onThemeChange(t.id)}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,
                  padding: '9px 4px', borderRadius: 11, cursor: 'pointer',
                  border: `2px solid ${active ? 'rgba(37,99,235,.5)' : 'transparent'}`,
                  background: active ? 'var(--active-nav)' : 'var(--surface2)',
                  transition: 'all .15s',
                }}
              >
                <div style={{ width: 28, height: 28, borderRadius: '50%', background: t.swatch, boxShadow: '0 2px 8px rgba(0,0,0,.15)', flexShrink: 0 }} />
                <div style={{ fontSize: 9, fontWeight: 700, color: 'var(--text-color-calendar)', textAlign: 'center', lineHeight: 1.2 }}>{t.name}</div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default ManageTab;
